import lang from "element-ui/lib/locale/lang/pl";
import locale from "element-ui/lib/locale"; // TODO - configure language with translation plugin
import DSButton from "./ds-button";
import DSInput from "./ds-input";
import DSLabel from "./ds-label";
import DSSelect from "./ds-select";
import DSCheckbox from "./ds-checkbox";
import DSLoader from "./ds-loader.vue";
import DSFetchingError from "./ds-fetching-error";
import DsCollapseMenu from "./ds-collapse.menu";
import DsDropdownMenu from "./ds-dropdown-menu";
import DsBreadcrumbs from "./ds-breadcrumbs/ds-breadcrumbs";
import DsContentHeader from "./ds-content-header";
import DsContentBox from "./ds-content-box";
import DsCheckboxSwitch from "./ds-checkbox-switch";
import DsSlider from "./ds-slider";
import DsPagination from "./ds-pagination";
import DsTabsBox from "./ds-tabs-box";
import DsTab from "./ds-tab";
import DsDateTimePikcer from "./ds-datetime-picker";
import DsMultiselect from "./ds-multiselect";
import DsTextarea from "./ds-textarea";
import DsTableButton from "./ds-table-button";
import DsSearchInput from "./ds-search-input";
import Table from "buefy/src/components/table/Table";
import TableColumn from "buefy/src/components/table/TableColumn";
import DsFileInput from "./ds-file-input";

locale.use(lang);

export default {
  DSButton,
  DSInput,
  DSLabel,
  DSSelect,
  DSCheckbox,
  DSLoader,
  DSFetchingError,
  DsCollapseMenu,
  DsDropdownMenu,
  DsBreadcrumbs,
  DsContentHeader,
  DsContentBox,
  DsCheckboxSwitch,
  DsSlider,
  DsTable: Table,
  DsTableColumn: TableColumn,
  DsPagination,
  DsTabsBox,
  DsTab,
  DsDateTimePikcer,
  DsMultiselect,
  DsTextarea,
  DsTableButton,
  DsSearchInput,
  DsFileInput
};



//////////////////
// WEBPACK FOOTER
// ../panel-theme/src/js/widgets/index.js
// module id = null
// module chunks = 